import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { tableHeader } from '../../../models/AccountDetailsVM';
import { SliderModelService } from '../../../services/infrastructure/sliderModel.service';

@Component({
  selector: 'app-retailer-search',
  templateUrl: './retailer-search.component.html',
  styleUrls: ['./retailer-search.component.scss']
})

export class RetailerSearchComponent implements OnInit, OnDestroy {
  filterArray = [];
  filter: any;
  // set table header data
  headerList: tableHeader[] = [];
  ApiData: any[];
  // data souce list
  dataSourceList: any[];
  selected_account: number = 0;
  headerSubscription: any;
  accountSelected = false;

  constructor(private loaderService: LoaderService,
    private sliderService: SliderModelService) {
  }

  ngOnInit() {
    this.sliderService.initializeRetailerDataSliderValue.subscribe(data => {
      this.getAccountData(data);
    });
    this.filterArray = [
      { label: 'Account Name', column: 'accountName' },
      { label: 'Account Number', column: 'account' },
      { label: 'City', column: 'city' },
      { label: 'State / Province', column: 'state' },
      { label: 'Parent Name', column: 'parentName' },
      { label: 'Parent Number', column: 'parentNumber' }];
  }

  ngOnDestroy() {
  }

  // On sigle row
  TableRowClicked(e: any) {
    if (e && e.rowData) {
      this.accountSelected = true;
      this.selected_account = e.rowData.account;
    }
  }

  // Set header and table
  setHeaderAndTable() {
    this.headerList = [
      { headertxt: 'Account', columnfield: 'account', className: 'mat-header-cell accountName accountId' },
      { headertxt: 'Account Name', columnfield: 'accountName', className: 'mat-header-cell accountName' },
      { headertxt: 'City', columnfield: 'city', className: 'mat-header-cell accountCity' },
      { headertxt: 'State/Province', columnfield: 'stateDes', className: 'mat-header-cell accountState' },
      { headertxt: 'Parent Number', columnfield: 'parentNumber', className: 'mat-header-cell parentNumber' },
      { headertxt: 'Parent Name', columnfield: 'parentName', className: 'mat-header-cell parentName' }
    ];
  }

  // Get Account data
  getAccountData(data: any) {
    this.loaderService.setLoaderStatus(true);
    if (data) {
      setTimeout(() => {
        let account_data: any[] = [];
        data.forEach(value => {
          account_data.push({
            isAccountRowSelected: false,
            userId: "",
            account: value.accountNumber,
            accountName: value.accountName,
            city: value.accountCity,
            state: value.accountState,
            stateDes: value.accountStateDesc,
            parentNumber: value.parentNumber,
            parentName: value.parentName
          })
        });
        this.dataSourceList = account_data;
        this.ApiData = account_data;
        this.setHeaderAndTable();
        this.loaderService.setLoaderStatus(false);
      }, 1000);
    }
  }

  // Filter Grid
  filterGrid(e: any) {
    if (e) {
      const accountNo = e.accountNo ? e.accountNo.split(',') : [];
      const accountName = e.accountName ? e.accountName.split(',') : [];
      const city = e.city ? e.city.split(',') : [];
      const state = e.state ? e.state : [];
      const parentName = e.parentName ? e.parentName.split(',') : [];
      const parentNumber = e.parentNumber ? e.parentNumber.split(',') : [];

      this.dataSourceList = this.ApiData.filter(x => ((accountNo.length > 0 ? accountNo.find(y => x.account == +(y.trim())) : true) &&
        (accountName.length > 0 ? accountName.find(y => (x.accountName.toLowerCase().indexOf(y.toLowerCase().trim())) !== -1) : true) &&
        (city.length > 0 ? city.find(y => (x.city.toLowerCase().indexOf(y.toLowerCase().trim())) !== -1) : true) &&
        (state.length > 0 ? state.find(y => (x.stateDes.toLowerCase().indexOf(y.toLowerCase().trim())) !== -1) : true) &&
        (parentName.length > 0 ? parentName.find(y => (x.parentName.toLowerCase().indexOf(y.toLowerCase().trim())) !== -1) : true) &&
        (parentNumber.length > 0 ? parentNumber.find(y => x.parentNumber == +(y.trim())) : true)
      ));
    }
    else {
      this.dataSourceList = this.ApiData;
    }
  }

  selectAccountClicked() {
    if (this.selected_account !== 0) {
      this.sliderService.selectedRetailerAccount.next(this.selected_account);
      this.sliderService.close();
    }
  }
}
